import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { gql, useMutation } from '@apollo/client';
import ErrorPage from '../ErrorPage/ErrorPage';
import { incrementMetric } from '../../Services/Datadog';

export const SEND_LOG_MESSAGE = gql`
  mutation SendLogMessage($level: LogLevel!, $message: String!) {
    sendLogMessage(level: $level, message: $message) {
      logMessageSent
    }
  }
`;

/**
 * ApplicationError Component
 *
 * This component is responsible for displaying a user-friendly message when known application errors occur.
 * It also logs these errors by sending a metric and separate log message to Datadog, helping us track and monitor issues.
 *
 * Props:
 *  - customerMessage: A user-friendly message to display to the customer.
 *  - metricName: The name of the error metric for logging purposes.
 *  - logMessage: A more technical message for logging purposes.
 */
const ApplicationError = ({ metricName, logMessage, customerMessage }) => {
  const { formId } = useSelector((store) => store.formConfig);
  const [sendLogMessage] = useMutation(SEND_LOG_MESSAGE);

  useEffect(() => {
    incrementMetric({
      name: metricName,
      tags: {
        form_id: formId,
      },
    });

    sendLogMessage({
      variables: {
        level: 'ERROR',
        message: logMessage,
      },
    });
  }, [formId, metricName, logMessage]);

  return (
    <ErrorPage Icon={ErrorOutlineIcon} title="Oops something went wrong">
      <Typography>{customerMessage}</Typography>
    </ErrorPage>
  );
};

export default ApplicationError;
